import { fetch } from '@/utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryGoodsSkus(
  goodsId,
  {
    page, size, direction, sort,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods-skus`,
    method: 'get',
    params: {
      goodsId,
      page,
      size,
      direction,
      sort,
    },
  });
}

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _generateGoodsSkus(goodsId, values,) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods-skus/${goodsId}`,
    method: 'post',
    data: values,
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryGoodsSku(goodsSkuId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods-skus/${goodsSkuId}`,
    method: 'get',
  });
}

/**
 * 新增
 * @param  image
 * @param  price
 * @param code
 * @param description
 * @param images
 * @param  quantity
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _addGoodsSku(
  {
    image,
    price,
    code,
    description,
    images,
    quantity,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods-skus`,
    method: 'post',
    data: {
      image,
      price,
      code,
      description,
      images,
      quantity,
    },
  });
}

/**
 * 更新
 * @param goodsSkuId
 * @param  image
 * @param  price
 * @param code
 * @param description
 * @param images
 * @param  quantity
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateGoodsSku(goodsSkuId, {
  image,
  price,
  code,
  description,
  images,
  quantity,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods-skus/${goodsSkuId}`,
    method: 'patch',
    data: {
      image,
      price,
      code,
      description,
      images,
      quantity,
    },
  });
}

/**
 * 删除
 * @param goodsSkuId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteGoodsSku(goodsSkuId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods-skus/${goodsSkuId}`,
    method: 'delete',
  });
}
